export function casesSlider() {

	if ($(window).width() <= '968' && $(window).width() > '540') {
		$('.cases_card-slider__js').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: false,
			dots: true,
		});
	}
	else if ($(window).width() <= '540' && $(window).width() > '340') {
		$('.cases_card-slider__js').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: false,
			dots: true,
		});
	} else if ($(window).width() <= '340') {
		$('.cases_card-slider__js').slick({
			infinite: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			arrows: false,
			dots: true,
		});
	}
}